import React, { memo } from 'react';

interface Props {
  id: string;
  header: string | undefined;
}

const Header: React.FC<Props> = ({ id, header }) => {
  if (!header) return null;
  let handleScriptForHeader = header.replaceAll(/<script\b[^>]*>([\s\S]*?)<\/script>/gm,"");
  return (
    <div
      id={id}
      className="global-header-envelope"
      dangerouslySetInnerHTML={{ __html: handleScriptForHeader }}
    />
  );
};

export default memo(Header);
